// Imports => React
import React, {useMemo, memo, FC} from 'react';
import {Props} from './ac-icon.proptypes';
import clsx from 'clsx';

// Imports => Constants
import {THEMES, SIZES} from '@asdf-constants';

// Imports => Atoms
import {AcRipple} from '@asdf-atoms/ac-ripple';

const _CLASSES = {
  MAIN: 'ac-icon',
  CALLBACK: 'ac-icon--clickable',
  PREFIX: 'ac-icon--',
};
// Component
const AcIcon: FC<{icon: string, className?: string, callback?: any, size?: string}> = memo(({icon, className, callback, ...rest}) => {
  const handleCallback = event => {
    if (event && event.persist) event.persist();

    if (event && (event.key || event.which)) {
      const key = event.key || event.which;

      if (key && key !== 1 && (key !== 13 || key !== 'Enter')) return;
    }

    if (callback) callback(event);
  };

  const getStyleClassNames = useMemo(() => {
    return clsx(
      _CLASSES.MAIN,
      icon && `${_CLASSES.PREFIX}${icon}`,
      callback && _CLASSES.CALLBACK,
      className
    );
  }, [icon, className, callback]);

  const getRole = useMemo(() => {
    return callback ? 'button' : 'img';
  }, [callback]);

  const getRestProps = useMemo(() => {
    let result = rest;

    if (getRole === 'img') {
      result.alt = (rest && rest.title) || `icon: ${icon}`;
      result.title = (rest && rest.title) || ``;
    }

    return result;
  }, [getRole, rest]);

  return (
    <i
      className={getStyleClassNames}
      onClick={handleCallback}
      onKeyUp={handleCallback}
      role={getRole}
      {...getRestProps}
    >
      {callback && <AcRipple theme={THEMES.PITCH} size={SIZES.SMALL} simple />}
    </i>
  );
});

AcIcon.displayName = 'AcIcon';
AcIcon.propTypes = Props;

export {AcIcon};
export default AcIcon;
